import React from 'react';
import { useApi } from '../../../contexts/ApiContext';
import { Button, Modal } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { Reseller } from './reseller.type';

type Props = {
  id: number;
  name: Reseller['name'];
  onRequestClose: () => void;
}

export const DeleteReseller: React.FC<Props> = ({ id, name, onRequestClose }) => {
  const { callApi } = useApi();
  const history = useHistory();

  return (
    <Modal open onClose={onRequestClose} size="mini" >
      <Modal.Header>Delete reseller</Modal.Header>
      <Modal.Content>{`Are you sure to delete reseller ${name}`}</Modal.Content>
      <Modal.Actions>
        <Button
          negative
          onClick={() => callApi.delete(`/reseller/${id}`).then(() => {
            onRequestClose();
            history.go(0);
          })}>Delete</Button>
        <Button onClick={onRequestClose}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
}